import { DateOnly, subMonths } from '@if/core/date'
import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { getToday } from '@src/services/DateTimeProvider'
import { ETerm, getETermList } from '@src/types/constants'

export const LOAD_LOANS_MAX_COUNT = 200000
const LOAD_LOANS_DEFAULT_COUNT = 100000

// Same rules as the API's LoadLoansRequestDtoValidator: activation on or before today, first payment
// on or after today (no back-filled history) and after activation.
export const LoadLoansSchema = yup.object().shape({
  count: yup.number().required().integer().min(1).max(LOAD_LOANS_MAX_COUNT).default(LOAD_LOANS_DEFAULT_COUNT),
  term: yup.numberEnum(getETermList()).required().default(ETerm.Twelve),
  // Lazy defaults: read the day when the form is instantiated, not when the module loads.
  activationPlannedOn: yup
    .dateOnly()
    .required()
    .default(() => new DateOnly(subMonths(getToday(), 1)))
    .test(
      'activationPlannedOn-afterToday',
      () => t('admin.devTools.commands.loadLoans.activationAfterToday'),
      (value) => !value || value <= getToday(),
    ),
  firstPaymentExpectedOn: yup
    .dateOnly()
    .required()
    .default(() => getToday())
    .test(
      'firstPaymentExpectedOn-beforeToday',
      () => t('admin.devTools.commands.loadLoans.firstPaymentBeforeToday'),
      (value) => !value || value >= getToday(),
    )
    .test(
      'firstPaymentExpectedOn-Invalid',
      () => t('loan.error.firstPaymentEarlierThanActivationPlannedOn'),
      (value, context) => {
        const activation: DateOnly | null | undefined = (context.parent as { activationPlannedOn?: DateOnly | null })
          .activationPlannedOn
        return !value || !activation || activation < value
      },
    ),
})

export type LoadLoansDraft = yup.InferDraft<typeof LoadLoansSchema>
export type LoadLoansValues = yup.InferSubmit<typeof LoadLoansSchema>
